import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.tsx
import { useMemo } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CHECKABLE_FIELD_CLASSNAME_MAP = {
  variant: {
    primary: "pd:checkable-field--primary",
    secondary: "pd:checkable-field--secondary"
  }
};
var CheckableField = _a => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      image,
      secondaryAction,
      variant = "primary",
      badge,
      validation,
      validationMessage,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "image", "secondaryAction", "variant", "badge", "validation", "validationMessage", "children", "className"]);
  const context = useMemo(() => ({
    id,
    name,
    label,
    description,
    image,
    secondaryAction,
    badge,
    validation,
    validationMessage
  }), [id, name, label, description, image, secondaryAction, badge, validation, validationMessage]);
  return /* @__PURE__ */jsx(CheckableFieldContext.Provider, {
    value: context,
    children: /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({}, rest), {
      className: clsx("pd:checkable-field", CHECKABLE_FIELD_CLASSNAME_MAP.variant[variant], className),
      children
    }))
  });
};
var CheckableField_default = CheckableField;
export { CheckableField_default };